import { Skeleton } from '@/components/ui/skeleton';

interface CollectionGridSkeletonProps {
  count?: number;
  showCreateCard?: boolean;
}

export function CollectionGridSkeleton({ count = 5, showCreateCard = true }: CollectionGridSkeletonProps) {
  return (
    <div className="grid grid-cols-2 gap-3">
      {/* Create card placeholder */}
      {showCreateCard && (
        <div className="aspect-[3/4] rounded-2xl border-2 border-dashed border-muted/30 bg-muted/5 flex flex-col items-center justify-center gap-3">
          <Skeleton className="w-14 h-14 rounded-full" />
          <Skeleton className="h-4 w-24" />
        </div>
      )}

      {/* Collection card skeletons */}
      {Array.from({ length: count }).map((_, i) => (
        <div 
          key={i} 
          className="aspect-[3/4] rounded-2xl overflow-hidden bg-surface-2 border border-border"
        >
          {/* Image mosaic skeleton - 2x2 grid */}
          <div className="w-full h-full relative">
            <div className="absolute inset-0 grid grid-cols-2 grid-rows-2 gap-0.5">
              <Skeleton className="w-full h-full rounded-none" />
              <Skeleton className="w-full h-full rounded-none" />
              <Skeleton className="w-full h-full rounded-none" />
              <Skeleton className="w-full h-full rounded-none" />
            </div>

            {/* Bottom content skeleton */}
            <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/60 to-transparent">
              <Skeleton className="h-4 w-3/4 bg-white/20" />
              <Skeleton className="h-3 w-1/3 mt-1.5 bg-white/10" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
